// @flow
import type { PrintProduct } from './PrintProduct';

export const APPROVAL_STATUS = {
  notApplicable: 'NOT_APPLICABLE',
  draft: 'DRAFT',
  pending: 'PENDING',
  approved: 'APPROVED',
  declined: 'DECLINED',
};

export type ApprovalStatus = $Values<typeof APPROVAL_STATUS>; //eslint-disable-line

export type Approval = {
  +approvalStatus: ApprovalStatus,
  +approvalCreatedDate: string,
  +requestedBy: string,
  +printProduct: PrintProduct,
  +id: string,
  isHidden?: boolean,
};

export type PendingApprovalCount = {
  +pendingCount: number,
};

export type ApprovalList = {
  +items: Array<Approval>,
  +total: number,
};
